import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as C}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const e=t("thumb_up",C`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_66162"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_66162)">
                <path
                    d="M21 7.99961C21.5333 7.99961 22 8.19961 22.4 8.59961C22.8 8.99961 23 9.46628 23 9.99961V11.9996C23 12.1163 22.9833 12.2413 22.95 12.3746C22.9167 12.5079 22.8833 12.6329 22.85 12.7496L19.85 19.7996C19.7 20.1329 19.45 20.4163 19.1 20.6496C18.75 20.8829 18.3833 20.9996 18 20.9996H7V7.99961L13 2.04961C13.25 1.79961 13.5458 1.65378 13.8875 1.61211C14.2292 1.57044 14.5583 1.63294 14.875 1.79961C15.1917 1.96628 15.425 2.19961 15.575 2.49961C15.725 2.79961 15.7583 3.10794 15.675 3.42461L14.55 7.99961H21ZM9 8.84961V18.9996H18L21 11.9996V9.99961H12L13.35 4.49961L9 8.84961ZM4 20.9996C3.45 20.9996 2.97917 20.8038 2.5875 20.4121C2.19583 20.0204 2 19.5496 2 18.9996V9.99961C2 9.44961 2.19583 8.97878 2.5875 8.58711C2.97917 8.19544 3.45 7.99961 4 7.99961H7V9.99961H4V18.9996H7V20.9996H4Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `),l=t("thumb_up_filled",C`
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <mask
                id="mask0_18104_66162"
                style="mask-type:alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24">
                <rect
                    width="24"
                    height="24"
                    fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_18104_66162)">
                <path
                    d="M21 7.99934C21.5333 7.99934 22 8.19934 22.4 8.59934C22.8 8.99934 23 9.46601 23 9.99934V11.9993C23 12.116 22.9875 12.241 22.9625 12.3743C22.9375 12.5077 22.9 12.6327 22.85 12.7493L19.85 19.7993C19.7 20.1327 19.45 20.416 19.1 20.6493C18.75 20.8827 18.3833 20.9993 18 20.9993H10C9.45 20.9993 8.97917 20.8035 8.5875 20.4118C8.19583 20.0202 8 19.5493 8 18.9993V8.82434C8 8.55767 8.05417 8.30351 8.1625 8.06184C8.27083 7.82017 8.41667 7.60767 8.6 7.42434L14.025 2.02434C14.275 1.79101 14.5708 1.64934 14.9125 1.59934C15.2542 1.54934 15.5833 1.60767 15.9 1.77434C16.2167 1.94101 16.4458 2.17434 16.5875 2.47434C16.7292 2.77434 16.7583 3.08267 16.675 3.39934L15.55 7.99934H21ZM4 20.9993C3.45 20.9993 2.97917 20.8035 2.5875 20.4118C2.19583 20.0202 2 19.5493 2 18.9993V9.99934C2 9.44934 2.19583 8.97851 2.5875 8.58684C2.97917 8.19517 3.45 7.99934 4 7.99934C4.55 7.99934 5.02083 8.19517 5.4125 8.58684C5.80417 8.97851 6 9.44934 6 9.99934V18.9993C6 19.5493 5.80417 20.0202 5.4125 20.4118C5.02083 20.8035 4.55 20.9993 4 20.9993Z"
                    fill="#FCFCFC" />
            </g>
        </svg>
    `);export{e as ThumbUp,l as ThumbUpFilled};
